import { jsx as _jsx } from "react/jsx-runtime";
export function OfferStageTest() {
    return _jsx("p", { children: "TODO OfferStageBar showcase" });
}
